export default [
  {
    name: 'event-wa',
    path: '/event/wa',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Parâmetros do WhatsApp',
      icon: 'dvr',
      label: 'Configurações gerais'
    }
  }
]
